<template>
  <DelDialog
    width="700px"
    :showClose="true"
    :dialogVisible="inviteAddVisible"
    :showButton="false"
    @handleClose="handleCancel"
  >
    <template #title>{{ $t("managementV2.invite") }}</template>
    <div class="invite-user">
      <div class="invite-left">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item :label="$t('managementV2.account')" prop="emailOrPhone">
            <el-input v-model="ruleForm.emailOrPhone" :placeholder="$t('managementV2.enterPhoneOrEmail')"></el-input>
          </el-form-item>
          <el-form-item prop="aliasName" :label="$t('managementV2.name')">
            <el-input v-model.trim="ruleForm.aliasName" :placeholder="$t('managementV2.pleaseinputName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('managementV2.role')" prop="roleId">
            <el-select v-model="ruleForm.roleId" :placeholder="$t('managementV2.pleaseselectRole')">
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="$i18n.locale === 'zh' ? item.name : $roleCase[item.roleType]"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn-group">
            <el-button size="small" @click="handleCancel">{{$t('common.cancel')}}</el-button>
            <el-button size="small" type="primary" @click="handleSubmit">{{$t('common.ok')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="invite-right" v-if="false">
        <div class="img-content">
          <img :src="urlBase64" width="168" />
          <div class="copy" @click="handleCopy">{{$t('managementV2.copyLink')}}</div>
          <div class="desc">{{$t('managementV2.toWechatOrQQ')}}</div>
        </div>
      </div>
    </div>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import { onCopy } from '@/utils/index';
import { createTeamQrCode, inviteMembers, inviteMembersByPhone } from "@/services/teamManagement";

export default {
  name: 'InviteUser',
  props: {
    inviteAddVisible: {
      type: Boolean,
      default () {
        return false;
      }
    },
    roleList: {
      type: Array,
      default () {
        return [];
      }
    },
  },
  components: {
    DelDialog,
  },
  data () {
    let validateEmail = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('managementV2.enterPhoneOrEmail')));
      } else if(!this.emailReg.test(value)&&!this.phoneReg.test(value)) {
        return callback(new Error(this.$t('managementV2.correctPhoneOrEmail')));
      }
      callback();
    };
    var username = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('project.nameTip')));
      } else if (value.length < 2) {
        callback(new Error(this.$t('managementV2.nameContainsMin')));
      } else if (value.length > 10) {
        callback(new Error(this.$t('managementV2.nameContainsMax')));
      }
      callback();
    };
    let roleId = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('managementV2.pleaseselectRole')));
      }
      callback();
    };
    return {
      urlBase64: '',
      qrCodeUrl: '',
      ruleForm: {
        aliasName: '',
        emailOrPhone: '',
        roleId: '',
      },
      emailReg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      phoneReg: /^(?:(?:\+|00)86)?1\d{10}$/,
      rules: {
        aliasName: [{ required: true, validator: username, trigger: "blur" }],
        emailOrPhone: [{ required: true, validator: validateEmail, trigger: "blur" }],
        roleId: [{ required: true, validator: roleId, trigger: "change" }],
      }
    }
  },
  methods: {
    async handleSubmit () {
      let flag = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          flag = false;
        }
      });
      if (flag) {
        return;
      }
      let params = {
        roleName: this.roleList.find((val) => val.id == this.ruleForm.roleId).name,
        ...this.ruleForm,
      }
      let resp = {};
      if (this.phoneReg.test(params.emailOrPhone)) {
        params.loginPhone = params.emailOrPhone;
        delete params.emailOrPhone;
        resp = await inviteMembersByPhone(params);
      } else if (this.emailReg.test(params.emailOrPhone)) {
        params.email = params.emailOrPhone;
        delete params.emailOrPhone;
        resp =  await inviteMembers(params);
      }
      let { success } = resp;
      if (!success) {
        return;
      }
      this.$message.closeAll();
      this.$message.success(this.$t("managementV2.invitationSent"));
      this.$emit('updateTeamList');
      this.handleCancel();
    },
    handleCancel () {
      this.urlBase64 = '';
      this.qrCodeUrl = '';
      this.$refs.ruleForm.resetFields();
      this.$emit('handleCancel');
    },
    async getTeamQrCode () {
      const { success, result } = await createTeamQrCode();
      if (success) {
        this.urlBase64 = 'data:image/png;base64,' + result.urlBase64;
        this.qrCodeUrl = result.qrCodeUrl;
      }
    },
    handleCopy () {
      onCopy(this.qrCodeUrl);
      this.$message.closeAll();
      this.$message.success(this.$t('common.copySuccess'));
    }
  },
  watch: {
    inviteAddVisible: {
      handler (newVal) {
        if (newVal) {
          this.getTeamQrCode();
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>
